import { useEffect, useState } from 'react';

export default function HeroSection() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSignup = () => {
    document.getElementById('signup')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative w-full h-screen min-h-[700px] flex flex-col overflow-hidden"
    >
      {/* Parallax Background */}
      <div
        className="absolute inset-0 w-full h-full"
        style={{ transform: `translateY(${scrollY * 0.35}px)` }}
      >
        <img
          src="https://public.readdy.ai/ai/img_res/2764c4dd8150d7df30cc01dfb37064e9.jpg"
          alt="Lake Claiborne at golden hour"
          className="w-full h-full object-cover object-center scale-110"
        />
      </div>

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/60" />

      {/* Navbar */}
      <nav className="relative z-10 w-full flex items-center justify-between px-6 md:px-12 py-5">
        <a href="/" className="flex items-center gap-3">
          <img
            src="https://public.readdy.ai/ai/img_res/7b32f896-56e9-40d0-9374-4218a73d8bc8.png"
            alt="Lake Claiborne Rentals Logo"
            className="h-12 w-auto object-contain"
          />
          <span className="text-white font-serif text-lg md:text-xl font-semibold leading-tight drop-shadow">
            Lake Claiborne<br />
            <span className="text-teal-300 font-normal italic text-base md:text-lg">Rentals</span>
          </span>
        </a>
        <span className="text-white/90 text-sm font-medium tracking-widest uppercase border border-white/40 rounded-full px-4 py-1.5 backdrop-blur-sm">
          Coming Soon
        </span>
      </nav>

      {/* Hero Content */}
      <div className="relative z-10 flex-1 flex flex-col items-center justify-center text-center px-4 w-full">
        <span className="inline-flex items-center gap-2 bg-teal-500/80 backdrop-blur-sm text-white text-xs font-semibold tracking-widest uppercase rounded-full px-4 py-1.5 mb-8">
          <i className="ri-calendar-line text-sm" />
          Rental Directory Launching Soon — Homer, Louisiana
        </span>

        <h1 className="text-white font-serif text-5xl md:text-7xl lg:text-8xl leading-tight mb-6 drop-shadow-lg">
          Find Your Perfect<br />
          <span className="italic text-teal-300">Lake Claiborne Rental</span>
        </h1>

        <p className="text-white/85 text-lg md:text-xl max-w-2xl leading-relaxed mb-10 drop-shadow">
          The premier directory of short-term rental properties on Lake Claiborne — browse handpicked cabins, cottages, and waterfront homes all in one place.
        </p>

        <button
          onClick={scrollToSignup}
          className="whitespace-nowrap bg-teal-500 hover:bg-teal-400 text-white font-semibold text-base px-8 py-4 rounded-full transition-all duration-300 hover:scale-105 cursor-pointer shadow-lg"
        >
          Get Notified at Launch
        </button>
      </div>

      {/* Scroll Indicator */}
      <div className="relative z-10 flex justify-center pb-8">
        <button
          onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
          className="text-white/70 hover:text-white transition-colors cursor-pointer animate-bounce"
          aria-label="Scroll down"
        >
          <i className="ri-arrow-down-line text-2xl" />
        </button>
      </div>
    </section>
  );
}
